import { BaseLayout } from "@components/general/base_layout";
import { Outlet } from "react-router-dom";

export const MadingPage = () => {
  return (
    <BaseLayout>
      <Outlet />
    </BaseLayout>
  );
};
